/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.inventory.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.inventory = {};
proto.witbooking.backoffice.inventory.v1 = require('./inventory_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest,
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse>}
 */
const methodDescriptor_InventoryAPI_GetInventoryLines = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.inventory.v1.InventoryAPI/GetInventoryLines',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest,
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest,
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse>}
 */
const methodInfo_InventoryAPI_GetInventoryLines = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient.prototype.getInventoryLines =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/GetInventoryLines',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_GetInventoryLines,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.inventory.v1.GetInventoryLinesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient.prototype.getInventoryLines =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/GetInventoryLines',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_GetInventoryLines);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest,
 *   !proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse>}
 */
const methodDescriptor_InventoryAPI_CreateInventoryLines = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.inventory.v1.InventoryAPI/CreateInventoryLines',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest,
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest,
 *   !proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse>}
 */
const methodInfo_InventoryAPI_CreateInventoryLines = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient.prototype.createInventoryLines =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/CreateInventoryLines',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_CreateInventoryLines,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.inventory.v1.CreateInventoryLinesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient.prototype.createInventoryLines =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/CreateInventoryLines',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_CreateInventoryLines);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest,
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse>}
 */
const methodDescriptor_InventoryAPI_GetCurrentInventoryState = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.inventory.v1.InventoryAPI/GetCurrentInventoryState',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest,
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest,
 *   !proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse>}
 */
const methodInfo_InventoryAPI_GetCurrentInventoryState = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient.prototype.getCurrentInventoryState =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/GetCurrentInventoryState',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_GetCurrentInventoryState,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.GetInventoryStateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.inventory.v1.GetInventoryStateResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient.prototype.getCurrentInventoryState =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/GetCurrentInventoryState',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_GetCurrentInventoryState);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest,
 *   !proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse>}
 */
const methodDescriptor_InventoryAPI_CreateSingleInventoryLine = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.inventory.v1.InventoryAPI/CreateSingleInventoryLine',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest,
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest,
 *   !proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse>}
 */
const methodInfo_InventoryAPI_CreateSingleInventoryLine = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient.prototype.createSingleInventoryLine =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/CreateSingleInventoryLine',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_CreateSingleInventoryLine,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.inventory.v1.CreateSingleInventoryLineResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient.prototype.createSingleInventoryLine =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/CreateSingleInventoryLine',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_CreateSingleInventoryLine);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest,
 *   !proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse>}
 */
const methodDescriptor_InventoryAPI_UpdateSingleInventoryLine = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.inventory.v1.InventoryAPI/UpdateSingleInventoryLine',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest,
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest,
 *   !proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse>}
 */
const methodInfo_InventoryAPI_UpdateSingleInventoryLine = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient.prototype.updateSingleInventoryLine =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/UpdateSingleInventoryLine',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_UpdateSingleInventoryLine,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.inventory.v1.UpdateSingleInventoryLineResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient.prototype.updateSingleInventoryLine =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/UpdateSingleInventoryLine',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_UpdateSingleInventoryLine);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest,
 *   !proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse>}
 */
const methodDescriptor_InventoryAPI_DeleteInventoryLine = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.inventory.v1.InventoryAPI/DeleteInventoryLine',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest,
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest,
 *   !proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse>}
 */
const methodInfo_InventoryAPI_DeleteInventoryLine = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse,
  /**
   * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIClient.prototype.deleteInventoryLine =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/DeleteInventoryLine',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_DeleteInventoryLine,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.inventory.v1.DeleteInventoryLineResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.inventory.v1.InventoryAPIPromiseClient.prototype.deleteInventoryLine =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.inventory.v1.InventoryAPI/DeleteInventoryLine',
      request,
      metadata || {},
      methodDescriptor_InventoryAPI_DeleteInventoryLine);
};


module.exports = proto.witbooking.backoffice.inventory.v1;

